module.exports = __webpack_public_path__ + "img/tag4.25713508.png";